import { render, staticRenderFns } from "./takeNotes.vue?vue&type=template&id=475d2466&scoped=true"
import script from "./takeNotes.vue?vue&type=script&lang=js"
export * from "./takeNotes.vue?vue&type=script&lang=js"
import style0 from "./takeNotes.vue?vue&type=style&index=0&id=475d2466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d2466",
  null
  
)

export default component.exports